import { render, staticRenderFns } from "./FleetVessels.vue?vue&type=template&id=715b140e&scoped=true"
import script from "./FleetVessels.vue?vue&type=script&lang=js"
export * from "./FleetVessels.vue?vue&type=script&lang=js"
import style0 from "./FleetVessels.vue?vue&type=style&index=0&id=715b140e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b140e",
  null
  
)

export default component.exports